import {
  DEFAULT_BACKGROUND_COLORS,
  DEFAULT_BUTTON_COLORS,
  DEFAULT_LINK_COLORS,
  TARGET_IDENTIFIERS
} from 'reservations/brand/constants';
import { ERROR } from 'reservations/brand/constants';

export const getPalette = (transformedBrandStyles: Record<string, any>) => {
  const page = getPageBackgroundPalette(transformedBrandStyles);

  return {
    page,
    button: getButtonColorsPalette(transformedBrandStyles),
    error: getErrorPalette(transformedBrandStyles),
    link: getLinkPalette(transformedBrandStyles),
    background: {
      default: page.background.main,
      secondary: DEFAULT_BACKGROUND_COLORS.secondary
    }
  };
};

export const getPageBackgroundPalette = (brandStyles: Record<string, any>) => ({
  background: {
    main:
      brandStyles?.[TARGET_IDENTIFIERS.PAGE]?.backgroundColor ||
      DEFAULT_BACKGROUND_COLORS.primary
  }
});

export const getButtonColorsPalette = (brandStyles: Record<string, any>) => ({
  font: {
    main:
      brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.color ||
      DEFAULT_BUTTON_COLORS.color,
    hover:
      brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.color ||
      DEFAULT_BUTTON_COLORS.hoverColor
  },
  background: {
    main:
      brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.backgroundColor ||
      DEFAULT_BUTTON_COLORS.backgroundColor,
    hover:
      brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.backgroundColor ||
      DEFAULT_BUTTON_COLORS.hoverBackgroundColor
  },
  border: {
    main: brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.borderColor || null,
    hover:
      brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.borderColor ||
      null
  }
});

export const getErrorPalette = (brandStyles: Record<string, any>) => ({
  main: brandStyles?.[TARGET_IDENTIFIERS.PAGE_ERROR]?.color || ERROR
});

export const getLinkPalette = (brandStyles: Record<string, any>) => ({
  main:
    brandStyles?.[TARGET_IDENTIFIERS.LINK]?.color || DEFAULT_LINK_COLORS.color,
  hover:
    brandStyles?.[TARGET_IDENTIFIERS.LINK_HOVER]?.color ||
    DEFAULT_LINK_COLORS.hoverColor
});
